module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "lang": "en"
    }
  }), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("“La Terre ")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Vorace")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Livre")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Élémentaire")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" I")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I")]), _c('span', {
    staticClass: "block_6",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Écrit")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" Par Rain Oxford")])]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Copyright © 201")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("6")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" Rain Oxford")])]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Tous")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("droits")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }), _vm._v("réservés")]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("Distribué par Babelcube, Inc. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("www.babelcube.com ")]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Traduit")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" par Camille ")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Fankhauser")])]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("“")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Babelcube")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" Books” et “")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Babelcube")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("” ")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("sont")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" des marques ")]), _vm._v("déposées de"), _c('span', {
    attrs: {
      "lang": "en"
    }
  }), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Babelcube")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" Inc.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ffef653","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_001.vue
// module id = 60
// module chunks = 0